var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Checkbox_Checked"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Yellow base",
    x: 2.66602,
    y: 2.6665,
    width: 26.6667,
    height: 26.6667,
    rx: 6,
    fill: "#FFE30A"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "black outline",
    x: 3.66602,
    y: 3.6665,
    width: 24.6667,
    height: 24.6667,
    rx: 5,
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "tick",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4509 10.9216C22.0465 11.3547 22.1781 12.1886 21.745 12.7842L16.8305 19.5416C16.1504 20.4768 14.8211 20.642 13.9327 19.9017L10.4798 17.0242C9.91408 16.5528 9.83765 15.7121 10.3091 15.1464C10.7805 14.5806 11.6212 14.5042 12.1869 14.9756L15.0928 17.3972L19.5884 11.2157C20.0215 10.6202 20.8554 10.4885 21.4509 10.9216Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.6f3d371e80b78c9c3a4b3e3acc740258.svg";
export { ForwardRef as ReactComponent };